import { createSlice } from '@reduxjs/toolkit'
import { getBranchList } from '../Thunk/branchThunk'

const initialState = {
    branchList:[],
}

export const branchSlice = createSlice({
        name:'branchThunk',
        initialState,
        reducers:{ 
        },

        extraReducers:(builder)=>{
        
            builder.addCase(getBranchList.fulfilled,(state,action)=>{
                state.branchList = action.payload
            })

        }
})

export default branchSlice.reducer